import { motion } from "framer-motion";
import { processSteps } from "@/data/site";
import { Eyebrow, Reveal, fadeUp, staggerContainer } from "../site/motion";

export default function Process() {
  return (
    <section data-testid="process-section" className="bg-white py-24 md:py-32">
      <div className="mx-auto w-full max-w-[1200px] px-6 md:px-8">
        <Reveal className="max-w-xl">
          <Eyebrow>How we work</Eyebrow>
          <h2 className="mt-5 text-3xl font-bold leading-[1.08] tracking-[-0.02em] text-slate-900 md:text-[2.6rem]">
            From idea to scalable technology.
          </h2>
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          className="relative mt-16 grid gap-12 md:grid-cols-4 md:gap-8"
        >
          <div
            className="absolute left-0 right-0 top-6 hidden border-t border-dashed border-slate-200 md:block"
            aria-hidden="true"
          />
          {processSteps.map((s, i) => (
            <motion.div key={s.num} variants={fadeUp} data-testid={`process-step-${s.num}`} className="group relative">
              <div className="relative z-10 grid h-12 w-12 place-items-center rounded-full border border-slate-200 bg-white font-mono text-[13px] tracking-[0.1em] text-slate-500 transition-[border-color,color,box-shadow] duration-300 group-hover:border-blue-600/50 group-hover:text-blue-600 group-hover:shadow-[0_0_0_6px_rgba(37,99,235,0.08)]">
                {s.num}
              </div>
              <h3 className="mt-6 text-lg font-semibold tracking-tight text-slate-900">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{s.desc}</p>
              {i < processSteps.length - 1 && (
                <span className="mt-6 block h-px w-10 bg-gradient-to-r from-blue-600 to-violet-600 md:hidden" aria-hidden="true" />
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
